import { render } from "./NoData.vue?vue&type=template&id=7732ec90&scoped=true&ts=true"
import script from "./NoData.vue?vue&type=script&lang=ts"
export * from "./NoData.vue?vue&type=script&lang=ts"

import "./NoData.vue?vue&type=style&index=0&id=7732ec90&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7732ec90"]])

export default __exports__